import "./components/ajax-loader";



// WEBPACK FOOTER //
// ./project/client/src/core/critical.js